import React, { useState, useEffect } from 'react';
import Plot from 'react-plotly.js';
import axios from 'axios';
import { getAuthHeaders } from '../../utils/auth';
import { API_URL_product_sales } from "../../constants";

const ProductSales = () => {
  const [productData, setProductData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const headers = getAuthHeaders();

    axios.get(API_URL_product_sales, { headers })
      .then(response => {
        setProductData(response.data);
        console.log("Product sales data:", response.data); // Log data on success
      })
      .catch(error => {
        console.error(error);
        setErrorMessage('Error fetching product sales data.');

        // Log the error response data if available
        if (error.response && error.response.data) {
          console.log("Error response data:", error.response.data);
        } else {
          console.log("Error message:", error.message);
        }
      })
      .finally(() => {
        console.log("Request completed."); // Always logs at the end of the request
      });
      }, []);

  return (
    <div>
      <h2>Product Sales Insights</h2>
      {errorMessage && <p>{errorMessage}</p>}

      {/* Top Products by Revenue */}
      <h3>Top Products by Revenue</h3>
      <Plot
        data={[
          {
            x: productData.map(d => d.description),
            y: productData.map(d => d.total_revenue),
            type: 'bar',
            marker: { color: 'green' },
          },
        ]}
        layout={{ title: 'Top Products by Revenue', xaxis: { title: 'Product Name' }, yaxis: { title: 'Total Revenue' } }}
      />

      {/* Sales by Product Type */}
      <h3>Sales by Product Type</h3>
      <Plot
        data={[
          {
            x: productData.map(d => d.product_type),
            y: productData.map(d => d.total_revenue),
            type: 'bar',
            marker: { color: 'blue' },
          },
        ]}
        layout={{ title: 'Sales by Product Type', xaxis: { title: 'Product Type' }, yaxis: { title: 'Total Revenue' } }}
      />
    </div>
  );
};

export default ProductSales;
